<template lang="pug">
v-container(fluid px-0 fill-height class=" tw-bg-gray-lighten-5 tw-items-start tw-content-start tw-overflow-x-hidden")
  kubiqa-website-themes-theme-d-components-shared-top-navigation
  v-row(no-gutters align="center" justify="space-around" class="  tw-pt-6")
    v-col(cols="12")
      div(class="tw-grid")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1 ")
          kubiqa-website-shared-widget-editor(
            page="rent"
            placement="header"
            @content="(content) => (content != null ? (defaultHeader = false) : (defaultHeader = true))"
          )
        div(v-if="defaultHeader" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
          div(class="tw-h-full  tw-items-center tw-flex")
            v-row(no-gutters justify="center")
              v-col(cols="9")
                span(class="tw-font-bold tw-text-white tw-text-2xl") Rent
  v-row(no-gutters)
    v-col
      div(class="tw-grid fill-height")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1 ")
          kubiqa-website-shared-widget-editor(
            page="rent"
            placement="description"
            @content="(content) => (content != null ? (defaultDescription = false) : (defaultDescription = true))"
            class=" fill-height"
          )
        div(v-if="defaultDescription" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12 tw-align-middle")
  v-row(no-gutters)
  v-row(align="start" justify="center" class="  tw-z-0 tw-mt-3 flex-grow-1 d-fex flex-row")
    v-col(cols="3")
      v-row(class=" tw-bg-white tw-border tw-border-gray-lighten-2 tw-rounded-md tw-mt-0")
        v-col
          v-row
            v-col
              span(class=" tw-font-bold tw-text-lg") Filters
          v-row
            v-col
              v-expansion-panels(flat accordion active-class="filters-active")
                v-expansion-panel
                  v-expansion-panel-header
                    span(class="tw--mx-1") Property type
                  v-expansion-panel-content
                    v-checkbox(label="House" class="tw-py-0 tw-my-0")
                    v-checkbox(label="Apartment" class="tw-py-0 tw-my-0")
                    v-checkbox(label="Office" class="tw-py-0 tw-my-0")
                    v-checkbox(label="Commercial" class="tw-py-0 tw-my-0")
                    v-checkbox(label="Plot" class="tw-py-0 tw-my-0")

          v-row
            v-col(class="tw-px-8")
              span Price rage
              v-range-slider(min="100000" max="100000000")

    v-col(cols="7")
      v-row
        v-col
          div(class="d-flex flex-row flex-wrap tw-w-full tw-mx-auto")
            div(v-for="item in 10" :key="item.id" class="tw-w-1/2 px-1")
              kubiqa-website-themes-theme-d-components-shared-listing-card
  v-row(class="tw-pt-24 ")
    v-col

  kubiqa-website-themes-theme-d-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      defaultHeader: null,
      defaultDescription: null,
    };
  },
};
</script>
<style lang="stylus">
.filters-active
    background-color: #ffffff


:focus
    outline: 0 !important
</style>
